import React from 'react'

const Byabasayikpatra = () => {
  return (
    <div>
      <div>
        <h3>शब्दभण्डार</h3>
        <h5>१. शब्द र अर्थको जोडा मिलाउनुहोस् ।</h5>
        <p><strong>प्रबन्ध - </strong>बन्दोबस्त, चाँजोपाँजो</p>
        <p><strong>अवगत - </strong>जानेको वा बुझेको</p>
        <p><strong>दीर्घकालीन - </strong>लामो समय</p>
        <p><strong>सङ्कलित - </strong>बटुलिएको</p>
        <p><strong>वितरण - </strong>बाँडफाँड</p>
        <p><strong>सहकार्य - </strong>दुई वा दुईभन्दा बढी व्यक्ति वा संस्थाले मिलेर गरिने काम</p>
        <p><strong>प्रस्ताव - </strong>कुनै कामको आरम्भ वा सम्पादनका लागि प्रस्तुत गरिएको विचार</p>
        <p><strong>यथाशीघ्र - </strong>जतिसक्दो चाँडो</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका शब्दको विपरीतार्थक शब्द लेख्नुहोस् :</h5>
        <p>हार: जित</p>
        <p>दाहिने: देब्रे</p>
        <p>रुनु: हाँस्नु</p>
        <p>आफ्नो: अर्काको</p>
        <p>दिन: रात</p>
        <p>आय: व्यय</p>
        <p>सक्कली: नक्कली</p>
        <p>निराशा: आशा</p>
        <p>प्रतिकूल: अनुकूल</p>
        <p>जस: अपजस</p>
        <p>प्रेम: घृणा</p>
        <p>आकर्षण: विकर्षण,द्वेष</p>
        <p>जटिल: सरल</p>
        <p>सबल: दुबर्ल</p>
        <p>सापेक्ष: निरपेक्ष</p>
        <p>हर्ष: विषाद, शोक</p>
        <p>सपना: विपना, वास्तविकता</p>
        <p>अनावश्यक: आवश्यक</p>
      </div>
      <hr/>
      <div>
        <h5>३. तलका शब्दको लघुतावाचक शब्द लेख्नुहोस् :</h5>
        <h5>(क) वस्तुको लघुत्ववाचक रूपहरू:</h5>
        <p>किरो: किरी</p>
        <p>कोदालो: कोदाली</p>
        <p>गाग्रो: गाग्री</p>
        <p>चिम्टा: चिम्टी</p>
        <p>चरो: चरी</p>
        <p>थाल: थाली</p>
        <p>ठेको: ठेकी</p>
        <p>पुस्तक: पुस्तिका / पाना</p>
        <h5>(ख) खाद्य र प्राकृतिक वस्तुको लघुत्ववाचक रूपहरू:</h5>
        <p>रोटी: टुक्रा</p>
        <p>सुन्तला: केस्रो</p>
        <p>भात: सिता</p>
        <p>पराल: त्यान्द्रो</p>
        <p>पानी: थोपा</p>
        <p>फूल: पत्र / दल</p>
        <p>केरा: कोसो</p>
      </div>
      
      <div>
        <hr/>
        <h3>बोध र अभिव्यक्ति</h3>
        <h5>१. पाठका आधारमा दिइएका प्रश्नको उत्तर भन्नुहोस् :</h5>
        <h5>(क) व्यावसायिक चिठीको सबैभन्दा माथि के लेखिन्छ ?</h5>
        <p>= व्यावसायिक चिठीको सबैभन्दा माथि प्रेषकको कार्यालय वा संस्थाको नाम र ठेगाना लेखिन्छ, जसले चिठी पठाएको हो।</p>
        <h5>(ख) व्यावसायिक चिठीमा पत्र सङ्ख्या र चलानी नम्बर कहाँ लेखिन्छ ?</h5>
        <p>= व्यावसायिक चिठीमा पत्र सङ्ख्या र चलानी नम्बर प्रेषकको कार्यालयको नाम र ठेगानाभन्दा मुनि, देब्रेपट्टि मितिभन्दा माथिल्लो लाइनमा लेखिन्छ।</p>
        <h5>(ग) व्यावसायिक चिठीको कुन भागमा कहाँनेर मिति लेखिन्छ ?</h5>
        <p>= व्यावसायिक चिठीको अग्रभागमा, प्रेषकको कार्यालयको नाम र ठेगानाभन्दा एक लाइन तल, दाहिनेपट्टि मिति लेखिन्छ।</p>
        <h5>(घ) व्यावसायिक चिठीमा सम्बोधन र विषयको रखाइक्रम कस्तो हुन्छ ?</h5>
        <p>= व्यावसायिक चिठीमा अग्र भागको देब्रेपट्टि पत्र सङ्ख्या र चलानी नम्बरको मुन्तिर पहिले सम्बोधन र ठेगाना लेखिन्छ, अनि त्यसको तल्लो लाइनको केन्द्र भागमा विषय लेखिन्छ।</p>
      </div>
      <hr/>
      <div>
        <h5>२. पाठमा उल्लेख भएअनुसार ज्वालामाई उपभोग्य वस्तु सङ्कलन तथा वितरण कम्पनी कोहलपुर, बाँकेले कर्नाली उत्पादन तथा वितरण केन्द्र चिसापानी, कैलालीलाई मिति २०७७/१२/२५ मा लेखेको पत्र कस्तो हुनसक्छ, अनुमान गरी लेख्नुहोस् ।</h5>
        <p>ज्वालामाई उपभोग्य वस्तु सङ्कलन तथा वितरण कम्पनी</p><p>
कोहलपुर, बाँके</p><p>

पत्र संख्या: ०७७/७-१५८</p><p>
चलानी नं.: ३५८</p><p>
मिति: २०७७/१२/२५</p><p>

श्री कर्नाली उत्पादन तथा वितरण केन्द्र</p><p>
चिसापानी, कैलाली</p><p>

विषय: वस्तु आपूर्ति सम्बन्धमा ।</p><p>

महोदय,</p><p>
उपरोक्त विषयमा हाम्रो कम्पनीले कर्नाली प्रदेश अन्तर्गत विभिन्न दुर्गम जिल्लाहरूमा उपभोग्य सामग्री आपूर्ति गर्ने कार्य गर्दै आएको व्यहोरा अवगत नै छ । हालै सम्पन्न बैठकमा गरिएको निर्णयअनुसार तपाईँको केन्द्रमार्फत प्राप्त हुने वस्तुहरू यथासक्य चाँडो बाँडफाँट गर्ने निर्णय भएकोले समयमै सामग्री आपूर्ति गर्नु हुन हार्दिक अनुरोध गर्दछौं ।</p><p>

हाल आवश्यकता अनुसार चामल, नुन, तेल, दाल, चिउरा, भुजा, साबुन, मास्क, सेनिटाइजर आदि सामग्रीहरू पर्याप्त मात्रामा पठाउनुहुन अनुरोध छ । ढुवानीको विवरण र लागत विवरण यस कार्यालयमा मितिको आधारमा पेस गरिदिनुहुन पनि अनुरोध गरिन्छ ।</p><p>

तपाईंको सकारात्मक सहयोगप्रति विश्वास लिँदै, आगामी दिनमा अझ प्रभावकारी सहकार्यको अपेक्षा राख्दछौं ।</p><p>

धन्यवाद ।</p><p>
भवदीय,</p><p>
[हस्ताक्षर]</p><p>
सञ्चालक</p><p>
ज्वालामाई उपभोग्य वस्तु सङ्कलन तथा वितरण कम्पनी</p><p>
कोहलपुर, बाँके</p>
      </div>
      <hr/>
      <div>
         <h5>३. हालसालै प्रकाशित पुस्तक पठाइदिन भनी तपाईंको घरनजिकै रहेको पुस्तक पसलले नेपाल प्रज्ञा प्रतिष्ठान, कमलादी, काठमाडौँलाई लेख्ने पत्रको नमुना तयार पार्नुहोस् ।</h5>
         <p>= गौरीशंकर पुस्तक पसल</p><p>
चितवन, नेपाल</p><p>

पत्र संख्या: ०८१/०८२–०३५</p><p>
चलानी नं.: १०२</p><p>
मिति: २०८१/०३/०५</p><p>

श्री नेपाल प्रज्ञा प्रतिष्ठान</p><p>
कमलादी, काठमाडौं</p><p>

विषय: हालसालै प्रकाशित पुस्तक पठाइदिनु बारे ।</p><p>

महोदय,</p><p>
सादर निवेदन छ,</p><p>
हामी चितवनमा अवस्थित गौरीशंकर पुस्तक पसल हाम्रा ग्राहक तथा पाठकहरूलाई नेपाली साहित्य, इतिहास, दर्शन, शिक्षाशास्त्र आदि विषयका पुस्तकहरू बिक्री वितरण गर्दै आइरहेका छौं । हालसालै तपाईँ संस्थानबाट प्रकाशित पुस्तकहरूको माग अत्यधिक आएको हुँदा ती पुस्तकहरू पठाइदिनुहुन अनुरोध गर्दछौं ।</p><p>

विशेषतः निम्न पुस्तकहरूको माग आएको छः</p><p>
१. नेपाली साहित्यको संक्षिप्त इतिहास</p><p>
२. समकालीन नेपाली कविता</p><p>
३. बाल साहित्य संग्रह - २०८०</p><p>
४. नेपाली लोककथा विशेषाङ्क</p><p>

यदि सम्भव भएमा पुस्तकसँगै मूल्यसूची र भुक्तानी विवरणसहितको बिल पनि पठाइदिनुहुन अनुरोध छ ।</p><p>

तपाईंको शीघ्र सकारात्मक सहयोगको अपेक्षासहित,</p><p>
धन्यवाद ।</p><p>

भवदीय,</p><p>
[हस्ताक्षर]</p><p>
प्रोपि. रामकृष्ण भुसाल</p><p>
गौरीशंकर पुस्तक पसल</p><p>
चितवन, नेपाल</p><p>
फोन: ९८४XXXXXXX</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएको चिठी पढ्नुहोस् र सोधिएका प्रश्नको उत्तर लेख्नुहोस् :</h5>
        <h5>(क) गाउँमा के सुरू भएको छ ?</h5>
        <p>= गाउँमा कृषि जागरण सुरू भएको छ ।</p>
        <h5>(ख) जगराम काकाले कसरी आम्दानी गर्नुभयो ?</h5>
        <p>= जगराम काकाले बाख्रापालन र तरकारी खेती गरेर आम्दानी गर्नुभयो ।</p>
        <h5>(ग) कोरोना भाइरसको महामारीपछि गाउँमा कस्तो परिवर्तन भएको छ?</h5>
        <p>= कोरोना भाइरसको महामारीपछि धेरै युवा गाउँ फर्केर कृषि पेशामा आबद्ध भएका छन्। यसले कृषिमा आधुनिकीकरण र व्यावसायीकरणको सुरुआत गराएको छ। साथै, गाउँमा विकासका कामहरू पनि धमाधम रूपमा अगाडि बढ्न थालेका छन्।</p>
        <h5>(घ) कृषिमा आधुनिकीकरण र व्यावसायिकीकरण भनेको के हो, स्पष्ट पार्नुहोस् ।</h5>
        <p>= कृषिमा आधुनिकीकरण भनेको आधुनिक यन्त्र, प्रविधि र विज्ञानको प्रयोग गरी खेतीपाती गर्ने प्रक्रिया हो भने व्यावसायिकीकरण भनेको कृषिलाई केवल परिवारको खानतिन्तको लागि नभई मुख्य व्यवसायका रूपमा विकास गर्नु हो। यसले उत्पादन वृद्धि गरी आम्दानी बढाउने लक्ष्य राख्छ।</p>
      </div>
      <hr/>
      <div>
        <h5>५. दिइएको कार्यालयीय चिठी पढ्नुहोस् र त्यसको प्रत्युत्तर लेख्नुहोस् :</h5>
        <p>पाठ्यक्रम विकास केन्द्र,</p><p>
सानोठिमी, भक्तपुर।</p><p>

मिति: २०७७/१०/२०</p><p>

श्री नेचासल्यान गाउँपालिका,</p><p>
सोलुखुम्बु।</p><p>

विषय: कार्यक्रम सञ्चालन सम्बन्धमा प्रत्युत्तर।</p><p>

श्रीमान् अध्यक्षज्यू,</p><p>

तपाईंहरुको पत्र प्राप्त भयो। पाठ्यक्रम तथा पाठ्यपुस्तकसम्बन्धी अभिमुखीकरण प्रशिक्षण र अन्तरक्रिया कार्यक्रम सञ्चालन गर्ने निर्णय गर्नुभएकोमा हामी आभारी छौं। यस किसिमका कार्यक्रमले शिक्षण सिकाइलाई अझ प्रभावकारी बनाउन सहयोग पुग्ने छ भन्नेमा हामी विश्वस्त छौं।</p><p>

कार्यक्रम सञ्चालन सम्बन्धी लागत र विस्तृत योजना तयार भएपछि कृपया हामीलाई सूचित गर्न हुन अनुरोध गर्दछौं। हाम्रो तर्फबाट पूर्ण सहयोग प्रदान गरिनेछ।</p><p>

सहयोगका लागि धन्यवाद व्यक्त गर्दै,</p><p>

शुभकामना सहित,</p><p>

……………</p><p>
निर्देशक</p><p>
पाठ्यक्रम विकास केन्द्र, सानोठिमी, भक्तपुर।</p>
      </div>
      <hr/>
      <div>
        <h5>६. दिइएको अनुच्छेदबाट चारओटा बुँदा टिपी एक तिहाइमा नबढ्ने गरी सारांश लेख्नुहोस् :</h5>
        <p><strong>बुँदाहरू :</strong></p>
        <p>१. नेपालमा पाँचवटा प्रकारका हावापानी प्रणाली पाइन्छन्।</p>
       <p>२. तराई, भावर, दुन तथा चुरे क्षेत्रहरूमा ऊष्ण मनसुनी र चुरे–महाभारत क्षेत्रमा न्यानो समशीतोष्ण हावापानी पाइन्छ।</p>
       <p>३. महाभारतको उच्च भाग तथा हिमालको तल्लो भागमा ठण्डा समशीतोष्ण र लेकाली क्षेत्रमा शुष्क ठण्डा हावापानी पाइन्छ।</p>
       <p>४. उच्च हिमाली क्षेत्रमा अत्यधिक चिसो हुने ऋणात्मक तापक्रमसहितको हिमाली हावापानी पाइन्छ।</p>
       <p><strong>सारांश :</strong></p>
       <p>नेपालमा कुल पाँच प्रकारका हावापानी पाइन्छन्। तराई, भावर, दुन र चुरे क्षेत्रहरूमा ऊष्ण मनसुनी, चुरेदेखि महाभारतसम्मको क्षेत्रमा न्यानो समशीतोष्ण, महाभारतको माथिल्लो भाग र हिमालको तलतिर ठण्डा समशीतोष्ण तथा लेकाली क्षेत्रमा शुष्क ठण्डा हावापानी पाइन्छ। यस्तै, उच्च हिमाली क्षेत्रमा अत्यधिक चिसो तथा ऋणात्मक तापक्रम भएको हिमाली हावापानी पाइन्छ।</p>
       <p>अनुच्छेदमा भएको शब्दसङ्ख्या : २२१</p>
       <p>एक तृतीयांशमा हुने शब्दसङ्ख्या : ७३</p>
       <p>सारांशमा भएको शब्दसङ्ख्या : ७३</p>
      </div>
    </div>
  )
}

export default Byabasayikpatra
